// Conditional privy popup
import get from 'lodash/get';

export default {
  mounted() {
    const userId = get(this, '$store.state.session.user.id');

    if (!userId) {
      // Needed for privy, var _d_site will not work inside script
      window._d_site = 'BB924CED6226F3A9A3091210'; // eslint-disable-line no-underscore-dangle
      import(/* webpackChunkName: 'privy-helper'  */ '@legacy/static/js/privy-helper.js'); // eslint-disable-line no-unused-expressions
    }
  },
};
